import { css } from '@emotion/react';

import { TOKENS } from '@root/components/www/home/tokens';

export const darkFooterLinkStyles = css`
  display: block;
  margin-bottom: ${TOKENS.space[12]};
  color: ${TOKENS.color.textSecondaryOnDark};
  font-family: ${TOKENS.font.sans};
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: ${TOKENS.color.onDark};
  }
`;
